module.exports = __webpack_public_path__ + "img/mobile_background.0f846b37.png";